export default __webpack_public_path__ + "36aad0bd9e49ca54d21d3b788468ee4b.png";